///<amd-module name="typeahead/core/logging/FlightOriginPopulationMetric" />

/**
 * Created by matterickson on 7/27/17.
 */

export class FlightOriginPopulationMetric {
    public isAkamaiPopulated: boolean;
    public isOriginChanged: boolean;
    public type: string;

    constructor(isAkamaiPopulated: boolean, isOriginChanged: boolean) {
        this.isAkamaiPopulated = isAkamaiPopulated;
        this.isOriginChanged = isOriginChanged;
        this.type = "flightOriginPopulation";
    }
}
